/**
 * config/lockstopKinds.ts — SSOT: quale lockstop SKU è "wide" (un solo
 * pezzo copre l'intera riga) o "narrow" (un pezzo per colonna estrema).
 *
 * Non derivabile a runtime da `LockstopFeatures` da solo (un pezzo con 2
 * colonne può essere "wide" — copre esattamente la riga — o parte di una
 * coppia "narrow" più larga altrove): è una classificazione di catalogo,
 * fissa per SKU, verificata con l'utente il 28-09-2026 insieme alle quote
 * di montaggio (`initdb/assets/lock_3d/LOCKSTOP*.json`). Il catalogo ha
 * solo questi 8 SKU (7 quote distinte, LOCKSTOP7 condivide la geometria di
 * LOCKSTOP5U) — aggiungerne uno nuovo richiede comunque toccare i JSON asset,
 * quindi aggiornare questa mappa nello stesso posto è naturale, non un
 * duplicato di un dato altrimenti disponibile.*/

import type { LockstopKind } from "../model/lockstopPlacement";

export const LOCKSTOP_KIND_BY_CODE: Record<string, LockstopKind> = {
  LOCKSTOP5: "narrow",
  LOCKSTOP5U: "narrow",
  LOCKSTOP7: "narrow",
  LOCKSTOP35: "wide",
  LOCKSTOP50: "wide",
  LOCKSTOP75: "wide",
  LOCKSTOP100: "wide",
  LOCKSTOP125: "wide",
};

/** `null` se il codice non è in catalogo (scelta non ancora nota/valida). */
export function lockstopKindForCode(code: string | null | undefined): LockstopKind | null {
  if (!code) return null;
  return LOCKSTOP_KIND_BY_CODE[code] ?? null;
}
